<div class="display-flex flex-align-center overflow-hidden gap-0-5em"
     customToolTip
     delay="0"
     [showToolTip]="enableTooltip"
     [contentTemplate]="tooltip">
  <ng-container *ngIf="name && color || icon">
    <img [src]="icon"
         *ngIf="!color; else avatar"
         [ngStyle]="{ width: iconSize + 'px' }">
    <ng-template #avatar>
      <app-avatar [color]="color"
                  [name]="avatarName || name"></app-avatar>
    </ng-template>
  </ng-container>
  <div class="display-flex flex-align-center gap-0-5em text-ellipsis"
       [ngClass]="{ missing: missing, warning: warning }"
       *ngIf="enableName">
    <div class="name text-ellipsis"
         [attr.data-slug]="slug">{{name}}<span *ngIf="category"> - <small>{{ category }}</small></span></div>
    <div *ngIf="badge"
         class="badge text-ellipsis"
         [customToolTip]="badgeHelpText | translate"
         [ngStyle]="{'backgroundColor': badgeColor}">
      {{ badge }}
    </div>
  </div>
  <ng-content></ng-content>
  <mat-icon class="material-icons-outlined icon-info missing-icon"
            *ngIf="missing || warning">warning</mat-icon>
  <mat-icon *ngIf="helpText"
            [customToolTip]="helpText | translate"
            class="material-icons-outlined icon-info"
            (mouseenter)="onHelpIconMouseEnter()"
            (mouseleave)="onHelpIconMouseLeave()">info</mat-icon>
</div>
<ng-template #tooltip>
  <app-source [enableTooltip]="false"
              [item]="item"
              [enableCategory]="true"
              [enableHelpText]="false"></app-source>
</ng-template>
